import { Button, Container, Typography, Stack } from "@mui/material";
import ErrorIcon from "../../../Components/Misc/ErrorIcon";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ViewLinkLayout from "../../../Layouts/MinifiedDashboard";
import Cover from "../../../Components/Misc/Cover";
import { FC } from "react";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";

interface ViewLinkErrorProps {}

const ViewLinkError: FC<ViewLinkErrorProps> = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const error = location.state?.error;

  return (
    <ViewLinkLayout>
      <Cover img={{ src: "/static/images/view-link-cover-fallback.png" }} />
      <Stack alignItems="center" justifyContent="center" width="100%" position="relative">
        <Container sx={{ textAlign: "center" }}>
          <ErrorIcon sx={{ mr: "auto", ml: "auto" }} icon={<ErrorOutlineIcon />} />
          <Typography mt={4} mb={2.5} component="h1" variant="h3">
            {t("page:error.unexpectedIssue")}
          </Typography>
          <Typography component="p" variant="subtitle2" color="text.tier" fontWeight={400} textAlign="center" mb={4}>
            {t("page:error.invalidLink")}
            <br />
            {t("page:error.linkIssues")}
            {error && (
              <>
                <br />
                {error}
              </>
            )}
          </Typography>
          <Button
            endIcon={<img src="/static/images/hand-wave.svg" width={20} height={20} alt="" />}
            color="primary"
            variant="contained"
          >
            {t("button:requestHelp")}
          </Button>
        </Container>
      </Stack>
    </ViewLinkLayout>
  );
};

export default ViewLinkError;
